/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { BEM } from "@adapptio/lib-components";
import React, { FC } from "react";

export interface IFieldLabelProps {
	className?: string;
	forId?: string;
}

export const FieldLabel: FC<IFieldLabelProps> = ({ children, className, forId }) => {
	const baseClass = BEM("edt-field-header", "label");

	if (className) {
		baseClass.add(className);
	}

	return (
		<label htmlFor={forId} className={baseClass.toClassName()}>
			{children}
		</label>
	);
};
